import dynamoDB from '@/aws/aws-dynamoDB';

export default async function (tagId, successCallback = e => e, errorCallback = e => e) {
  try {
    // verify that tag is not in use
    const allFiles = await dynamoDB.getAllDBFiles();
    const isInUse = allFiles.some((file) => {
      const tags = file.metadata && file.metadata.tags ? file.metadata.tags : [];
      return Object.entries(tags).map(([, tag]) => tag.id).includes(tagId);
    });

    if (isInUse) {
      errorCallback(new Error('Tag is in use'));
      return;
    }
    // delete file from database
    const result = await dynamoDB.deleteDBTag(tagId);

    // eslint-disable-next-line no-constant-condition
    if (result.$metadata.httpStatusCode >= 200 && result.$metadata.httpStatusCode < 300) {
      successCallback(tagId);
    } else {
      errorCallback(result);
    }
  } catch (e) {
    errorCallback(e);
  }
}
